// mcqSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpService from "../api-services/httpService";

// Create an asynchronous thunk to fetch MCQ data from the API
export const fetchMcqData = createAsyncThunk(
  "mcq/fetchMcqData",
  async (gettingArg) => {
    const response = await httpService.get(`/questions/getPracticeQuestions/${gettingArg.topic}/${gettingArg.difficulty}/${gettingArg.noOfQuestions}`)

    return response.data;
  }
);

// Create a slice of the state
const mcqSlice = createSlice({
  name: "mcq",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchMcqData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMcqData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchMcqData.rejected, (state, action) => {
        console.log("Rejected with:", action.error.message);
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default mcqSlice.reducer;
